import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { GeneralSetting } from '@apis/index'
import Button from '@components/button'
import Column from '@components/column'
import Table from '@components/table'
import Title from '@components/title'
import { useModal } from '@context/ModalContext'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import { deletesvg, edit, outlineuser } from '@assets/icons'
import styled from '@emotion/styled'
import theme from '@utils/theme'

const IssueTitleModal = ({ item }: { item?: any }) => {
  const { hideModal } = useModal()
  const [initialValues, setInitialValues] = useState({
    title: item?.value || '',
  })

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      const payload = {
        group: 'issue-titles',
        key: item?.key || `issue-title-${Date.now()}`,
        value: values.title,
      }

      if (item?.id) {
        await GeneralSetting.update({
          id: item.id,
          data: payload,
          state: 'issueTitles',
        })
      } else {
        await GeneralSetting.create({
          data: payload,
          state: 'issueTitles',
        })
      }
      hideModal()

      // Auto-refresh via reloading action or we can just refetch.
      GeneralSetting.getByGroup({ id: 'issue-titles', state: 'issueTitles' })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Fragment>
      <Column>
        <ModalTitle>{item ? 'Edit Issue Title' : 'Add Issue Title'}</ModalTitle>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          <Form>
            <Column>
              <Fields.Input
                name="title"
                label="Issue Title"
                placeholder="Enter title"
              />
              <Button type="submit" title="Save" width={100} height={45} />
            </Column>
          </Form>
        </Formik>
      </Column>
    </Fragment>
  )
}

const IssueTitle = () => {
  const { showModal } = useModal()

  // Assuming the `set` action puts the array in `data` or it's the root array directly.
  // RuleForm uses: Array.isArray(state[stateKey]?.data) ? state[stateKey].data : []
  const titlesData = useSelector((state: any) => {
    const target = state.issueTitles
    if (Array.isArray(target)) return target
    if (Array.isArray(target?.data)) return target.data
    return []
  })

  const fetchTitles = async () => {
    try {
      await GeneralSetting.getByGroup({
        id: 'issue-titles',
        state: 'issueTitles',
      })
    } catch (error) {}
  }

  useEffect(() => {
    fetchTitles()
  }, [])

  const columns = [
    { title: 'SN', key: 'sn', render: (_: any, i: number) => <p>{i + 1}</p> },
    { title: 'Title', key: 'value' },
  ]

  return (
    <Fragment>
      <Column>
        <Title
          textone="Settings"
          texttwo="Issue Titles"
          hasButton
          btnText="Add Issue Title"
          onButtonClick={() => showModal(<IssueTitleModal />)}
        />

        <Table
          text="Issue Titles"
          icon={outlineuser}
          columns={columns}
          data={titlesData}
          searchKeys={['value']}
          actions={[
            {
              icon: edit,
              key: 'edit',
              onClick: (item) => {
                showModal(<IssueTitleModal item={item} />)
              },
            },
            {
              icon: deletesvg,
              key: 'remove',
              onClick: async (item) => {
                try {
                  await GeneralSetting.remove({
                    id: item.id,
                    state: 'issueTitles',
                  })
                  // Refresh after removal
                  fetchTitles()
                } catch (e) {}
              },
            },
          ]}
        />
      </Column>
    </Fragment>
  )
}

export default IssueTitle

const ModalTitle = styled.p`
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 20px;
  text-align: center;
`
